import { PageHeader } from "@/components/layout/PageHeader";
import { CategoryTable } from "@/components/categories/CategoryTable";
import { CreateCategoryDialog } from "@/components/categories/CreateCategoryDialog";
import { useCategories } from "@/hooks/useCategories";

export default function CategoriesPage() {
  const { data: categories = [], isLoading, error } = useCategories();

  return (
    <div>
      <PageHeader title="Kategorie" action={<CreateCategoryDialog />} />
      {isLoading && (
        <div className="space-y-2">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="h-14 rounded-lg bg-slate-100 animate-pulse" />
          ))}
        </div>
      )}
      {error && <p className="text-destructive">Błąd ładowania: {error.message}</p>}
      {!isLoading && !error && <CategoryTable categories={categories} />}
    </div>
  );
}
